import { QueriesOptions, useQueries, UseQueryResult } from '@tanstack/react-query';
import { PortfolioDto } from '@unistocks/proxy/axios-client';
import {
  __portfoliosGet,
  getPortfoliosGetDefaultOptions,
  portfoliosGetQueryKey
} from '@unistocks/proxy/axios-client/PortfoliosQuery';

export const usePortfolios = <TResult = UseQueryResult<PortfolioDto>[]>(
  ids: string[],
  options?: QueriesOptions<PortfolioDto[]>,
  combine?: (result: UseQueryResult<PortfolioDto, Error>[]) => TResult
) =>
  useQueries({
    queries: ids.map(id => ({
      queryKey: portfoliosGetQueryKey(id),
      queryFn: __portfoliosGet,
      ...getPortfoliosGetDefaultOptions(),
      ...options
    })),
    combine
  });
